"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import axios from "axios";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import { useAppSelector } from "@/redux/store";
import { useLocalStorage } from "@/hooks/useStorage";
import MonumetricAd, { AdVariant } from "../MonumetricAd";
import SexyAd from "../SexyAd";

const SEXY_MATCHED_ORIGINS: string[] = [
  "hot-sexy-image-generator",
  "sexy-ai",
  "ai-hot-girl-generator",
  "ai-hot-girl-generator",
  "waifu-generator",
  "dopamine-girl-ai-generator",
  "ai-generated-girls",
  "anime-lingerie",
  "hot-asian-girl-image-generation",
  "sexy-asset-image-generator",
  "busty-girl-artwork-creation",
  "realistic-image-generator-hot-blondes",
  "hot-sexy-image-generator",
  "hot-anime-girl",
  "korean-girl-image-generation",
  "generate-sexy-babes-images",
  "thick-black-girls-art",
  "girls-in-bikinis-images",
  "sexy-pic",
  "sexy-butt-art-creation",
  "sexy-wife-art",
  "thick-girls-art-creation",
  "hot-latinas-art-generation",
  "sexy-e-girls",
  "hot-babe-images",
  "sexy-underwear-image-creator",
  "sexy-photo-generation",
  "sexy-black-dress-generator",
];

interface DynamicAdProps {
  variant: AdVariant;
  className?: string;
}

const DynamicAd: React.FC<DynamicAdProps> = ({ variant, className }) => {
  const [storedVIP, setStoredVIP] = useLocalStorage("isVIP", false);
  const isLargeScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("xl")
  );
  const searchParams = useSearchParams();
  const origin = searchParams?.get("origin");
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user.subscriptionType !== "free");
  const isVIP =
    Boolean(user && user.classification === "gooner") ||
    (origin && SEXY_MATCHED_ORIGINS.includes(origin)) ||
    storedVIP;

  useEffect(() => {
    async function checkOrigin() {
      if (!user) {
        if (origin && SEXY_MATCHED_ORIGINS.includes(origin)) {
          setStoredVIP(true);
        }
        return;
      }

      if ((origin && SEXY_MATCHED_ORIGINS.includes(origin)) || storedVIP) {
        if (user.classification === "gooner") return;

        try {
          const reqBody = {
            classification: "gooner",
          };
          await axios.patch(
            `${process.env.NEXT_PUBLIC_API_URL}/user/classification`,
            reqBody,
            {
              withCredentials: true,
            }
          );
          if (storedVIP) {
            setStoredVIP(false);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    checkOrigin();
  }, [user, origin]);

  if (isSubscribed) return null;

  if (isVIP) {
    return (
      <SexyAd
        variant={
          ["in-content-repeatable", "sticky-sidebar"].includes(variant)
            ? "square"
            : "banner"
        }
        className={className}
      />
    );
  }

  if (isLargeScreen) {
    return <MonumetricAd variant={variant} className={className} />;
  }

  return null;
};

export default DynamicAd;
